const DEFAULT_LIVELABEL_SETTINGS = {
    color: "#ffffff",
    border: "#000000",
    textAlign: "middle",
    fontSize: 24,
    fontWeight: "normal",
    content: "",
    distanceMin: 0.05,
    distanceMax: 399,
    textScale: "small",
    definition: "",
    backgroundOpacity: 0,
    paddingHorizontal: 0.5,
    paddingVertical: 0.5,
    backgroundColor: "#000000",
    backgroundRadius: 15,
};

module.exports = function (dst = {}) { return Object.assign({}, DEFAULT_LIVELABEL_SETTINGS, dst); };